import { LanguageService } from './../../../Services/languageService';
import { TPLProposal } from './../../../Models/TPLProposal';
import { Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { restURL } from '../../../Models/restURL';
import { Subscription } from 'rxjs';
import { renewalProposalService } from '../../../Services/renewalProposalService';
import { RenewBindMdl } from '../../../Models/RenewBindMdl';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import Swal from 'sweetalert2';

declare let $: any;
@Component({
  selector: 'RenewalBasicInfo',
  templateUrl: './RenewalBasicInfo.html',
  styleUrls: ['./RenewalBasicInfo.css']
})
export class RenewalBasicInfo implements OnDestroy {

  public prObj: TPLProposal = new TPLProposal();
  public bindObj: RenewBindMdl = new RenewBindMdl();
  public subscription: Subscription;
  public bindSubscription: Subscription;
  public LngSubscription: Subscription;
  public Lng: string;
  public isSubmitted: boolean = false;
  public disableAddDrivers: boolean;
  public isError: boolean;
  public EducationValidation: boolean = false;

  constructor(private router: Router, private http: HttpClient, private url: restURL, private proposalService: renewalProposalService, private lngService: LanguageService) {
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng
    });

    this.isError = false;
    this.disableAddDrivers = false;

    if (sessionStorage.getItem("rp") === null) {

      this.subscription = this.proposalService.getRenewProposal().subscribe(message => {
        this.prObj = message;
        if (this.prObj.InsuredStreetName == null || 0) {
          this.prObj.InsuredStreetName = '';
          this.prObj.streetNameExists = false;
        }
      });
      this.bindSubscription = this.proposalService.getRenewBindInfo().subscribe(message => { this.bindObj = message; });
      // if (this.bindObj.TplObj.st.StatusCode == "F") {
      //   Swal(this.bindObj.TplObj.st.StatusDesc);
      //   this.router.navigate(['/NewDashboard/Policy']);
      //   return;
      // }
     
    }
    else {
      this.prObj = this.proposalService.getRenewalProposalObj();
      this.bindObj = this.proposalService.getRenewalBindObj();
      
     
      // if (this.bindObj.TplObj.st.StatusCode == "F") {
      //   Swal(this.bindObj.TplObj.st.StatusDesc);
      //   this.router.navigate(['/NewDashboard/Policy']);
      //   return;
      // }
      if (sessionStorage.getItem("NoDriver") == "Y") {
        this.prObj.Drivers.push(this.prObj.insuredDriverObj);

      }
      sessionStorage.setItem("NoDriver", "N");

    }

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }

  }
  ngOnDestroy() {

  }

  cityChange(val) {

    this.prObj.RegionCode = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionCode;
    this.prObj.RegionNameEn = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
    this.prObj.RegionNameAr = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionNameAr;
    this.prObj.InsuredWCity = val;
    this.prObj.InsuredPOCity = val;
    this.prObj.InsuredAreaName = this.prObj.RegionCode;
    this.prObj.InsuredWAreaName = this.prObj.RegionCode;

  }

  ngAfterViewInit() {
    $(document).ready(function () {

      $('[data-toggle="popover"]').popover({
        placement: 'top',
        trigger: 'hover'
      });
    });
  }

  GoNext(valid) {

    this.isSubmitted = true;
    if (this.prObj.Insured_Education == null) {
      this.EducationValidation = true;
      return;
    }
    if (this.prObj.isInsured == false && this.prObj.isDriverRequired == false) {
      this.Lng == "ar" ? Swal("الرجاء اضافة سائق واحد للمتابعة") : Swal("You Have to add atleast one driver to proceed");
      return;
    }

    let index = this.prObj.Drivers.findIndex(t => t.DriverLicenseNo == this.prObj.InsuredIDNo);
    if (index >= 0) {
      this.prObj.Drivers[index].DriverMedicalConditions = this.prObj.insuredDriverObj.DriverMedicalConditions;
      this.prObj.Drivers[index].RoadConvictions = this.prObj.insuredDriverObj.RoadConvictions;
      this.prObj.Drivers[index].NumberOfYearsEachCountry = this.prObj.insuredDriverObj.NumberOfYearsEachCountry;
      this.prObj.Drivers[index].OtherCountriesLicenceHeld = this.prObj.insuredDriverObj.OtherCountriesLicenceHeld;
      this.prObj.Drivers[index].SaudiLicenceHeld = this.prObj.insuredDriverObj.SaudiLicenceHeld;
      this.prObj.Drivers[index].DriverProfession = this.prObj.InsuredProfessin;
      this.prObj.Drivers[index].DriverEducation = this.prObj.Insured_Education;
      this.prObj.Drivers[index].DriverChildrenYears = this.prObj.ChildrenUnder;

      this.prObj.Drivers[index].ResidenceBuildingNumber = Number(this.prObj.InsuredBuildingNo == undefined ? 0 : this.prObj.InsuredBuildingNo);
      this.prObj.Drivers[index].ResidenceCity = Number(this.prObj.InsuredCity == undefined ? 0 : this.prObj.InsuredCity);
      this.prObj.Drivers[index].ResidenceDistrict = this.prObj.InsuredDistName == undefined ? "" : this.prObj.InsuredDistName;
      this.prObj.Drivers[index].ResidenceStreet = this.prObj.InsuredStreetName == undefined ? "" : this.prObj.InsuredStreetName;
      this.prObj.Drivers[index].ResidenceAdditionalNumber = Number(this.prObj.InsuredAdditionalCode == undefined ? 0 : this.prObj.InsuredAdditionalCode);
      this.prObj.Drivers[index].ResidenceZipCode = Number(this.prObj.InsuredPostalCode == undefined ? 0 : this.prObj.InsuredPostalCode);
      this.prObj.Drivers[index].ResidenceUnitNumber = Number(this.prObj.InsuredUnitNo == undefined ? 0 : this.prObj.InsuredUnitNo);
      this.prObj.Drivers[index].ResidenceZone = this.prObj.InsuredAreaName == undefined ? "" : this.prObj.InsuredAreaName;

      this.prObj.Drivers[index].OfficeBuildingNumber = Number(this.prObj.OfficeBuildingNo == undefined ? 0 : this.prObj.OfficeBuildingNo);
      this.prObj.Drivers[index].OfficeCity = Number(this.prObj.OfficeCity == undefined ? 0 : this.prObj.OfficeCity);
      this.prObj.Drivers[index].OfficeDistrict = this.prObj.OfficeDistrict == undefined ? "" : this.prObj.OfficeDistrict;
      this.prObj.Drivers[index].OfficeStreet = this.prObj.OfficeStreet == undefined ? "" : this.prObj.OfficeStreet;
      this.prObj.Drivers[index].OfficeAdditionalNumber = Number(this.prObj.OfficeAdditionalCode == undefined ? 0 : this.prObj.OfficeAdditionalCode);
      this.prObj.Drivers[index].OfficeZipCode = Number(this.prObj.OfficePostalCode == undefined ? 0 : this.prObj.OfficePostalCode);
      this.prObj.Drivers[index].OfficeUnitNumber = Number(this.prObj.OfficeUnitNo == undefined ? 0 : this.prObj.OfficeUnitNo);
      this.prObj.Drivers[index].OfficeZone = this.prObj.OfficeZone == undefined ? "" : this.prObj.OfficeZone;
    }

    if (this.prObj.isInsured && this.prObj.InsuredDriverLicIssueDateExists == false) {
      let insured = this.prObj.Drivers.find(t => t.DriverLicenseNo == this.prObj.InsuredIDNo)
      if (insured) {
        insured.DriverLicIssueDate = this.prObj.InsuredDriverLicIssueDateAr;

      }
    }


    if (this.prObj.isInsured) {
      let insured = this.prObj.Drivers.find(t => t.DriverLicenseNo == this.prObj.InsuredIDNo)
      if (insured) {
        insured.DriverMaritalStatus = this.prObj.MStatus;
        insured.DriverMaritalStatusEn = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.MStatus)[0].MarstatusDesc_En;
        insured.DriverMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.MStatus)[0].MarstatusDesc_Ar;
      }
    }


    this.proposalService.saveRenewalProposalObj(this.prObj);
    this.proposalService.saveRenewalBindObj(this.bindObj);
    sessionStorage.setItem("rp", "Y");
    if (valid && (this.prObj.st.StatusCode != "F")) {
      if (this.prObj.isDriverRequired == true) {
        this.router.navigate(['NewDashboard/RenewalProposal/RenewalDriverInfo']);
      }
      else {
        this.router.navigate(['NewDashboard/RenewalProposal/RenewalPremiumInfo']);
      }
    }

  }

  OfficecityChange(val) {
    this.prObj.OfficeRegionCode = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionCode;
    this.prObj.OfficeZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }

  onSelectionChange(evt: any) {
    if (evt.target.value == "Yes") {
      this.prObj.AddDriverChk = true;

    }
    else {
      this.prObj.AddDriverChk = false;
    }
  }

  oncommercialSelectionChange(evt: any) {

  }

  checkDrivers(val) {
    if (val == false && this.prObj.isInsured == false) {
      this.prObj.isInsured = true;
      this.CheckMainDriver(this.prObj.isInsured);
    }
  }
  CheckMainDriver(value) {

    let index: number;
    //  alert(value);
    if (value == false) {
      this.prObj.isDriverRequired = true;
      this.disableAddDrivers = true;
      index = this.prObj.Drivers.findIndex(t => t.DriverLicenseNo == this.prObj.InsuredIDNo);
      if (index >= 0)
        this.prObj.Drivers.splice(this.prObj.Drivers.findIndex(t => t.DriverLicenseNo == this.prObj.InsuredIDNo), 1);
    }
    else {

      this.disableAddDrivers = false;
      // let  mainDriverCount = this.prObj.Drivers.filter(t => t.isInsured == true).length;
      let mainDriverLiceCount = this.prObj.Drivers.filter(t => t.DriverLicenseNo == this.prObj.InsuredIDNo).length;
      let mainDriverCount = this.prObj.Drivers.filter(t => t.isMainDriver == "1").length;
      if (mainDriverLiceCount > 0) {
        this.Lng == "ar" ? Swal("Driver ID Already Existed") : Swal("Driver ID Already Existed");
      }
      else {
        if (mainDriverCount == 0) {
          this.addInsuredAsMainDriver();
        }
        else {
          this.prObj.isInsured = false;
          this.Lng == "ar" ? Swal("لاتستطيع إضافة اكثر من سائق رئيسي واحد") : Swal("You can not add more than one main Driver");

        }
      }

    }
  }
  addInsuredAsMainDriver() {




    if (this.prObj.isInsured && this.prObj.InsuredDriverLicIssueDateExists == false) {
      this.prObj.insuredDriverObj.DriverLicIssueDateAr = this.prObj.InsuredDriverLicIssueDateAr;
      this.prObj.insuredDriverObj.DriverMaritalStatus = this.prObj.MStatus;

    }

    if (this.prObj.Drivers.length < 3) {
      this.prObj.Drivers.push(this.prObj.insuredDriverObj);
    }
    else {
      this.prObj.isInsured = false;
      this.Lng == "ar" ? Swal("لا يمكنك إضافة أكثر من ثلاثة سائقين") : Swal("You can not add more than three drivers");


    }
  }
  getHijri(event) {

  }
  CheckValidEducation(val) {
    if (val == null || val == undefined) {
      this.EducationValidation = true;
    } else {
      this.EducationValidation = false;
    }
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalBasicInfo/RenewalBasicInfo.ts